import React, { useMemo, useState } from "react";

import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import FilterMultiSelectExtractSAP from "./FilterMultiSelectExtractSAP";
import ButtonComponent from "./button/Button";



// CREATE OPTIONS
const getUniqueOptions = (
  data,
  config
) => {
  const uniqueMap = new Map();

  data.forEach((row, index) => {
    // CODE BASED DROPDOWNS
    if (
      config.codeField &&
      config.nameField
    ) {
      const code =
        row[config.codeField];

      const name =
        row[config.nameField];

      const extra =
        config.extraField
          ? row[config.extraField]
          : null;

      // IGNORE IF EVERYTHING EMPTY
      const isEmpty = (val) =>
        val === null ||
        val === undefined ||
        val === "";

      if (
        isEmpty(code) &&
        isEmpty(name) &&
        isEmpty(extra)
      ) {
        return;
      }

      // LABEL PARTS
      const parts = [];

      if (code) {
        parts.push(code);
      }

      if (name) {
        parts.push(name);
      }

      if (extra) {
        parts.push(extra);
      }

      const label =
        parts.join(" | ");

      // UNIQUE KEY
      const uniqueKey = code || name;

      uniqueMap.set(uniqueKey, {
        label,
        value: uniqueKey,
        actualValue: code,
      });
    }

    // NORMAL DROPDOWNS
    else {
      const value = row[config.key];

      // REMOVE EMPTY OPTIONS
      if (
        value == null ||
        value === ""
      ) {
        return;
      }

      uniqueMap.set(value, {
        label: value,
        value: value,
      });
    }
  });

  return [...uniqueMap.values()];
};

export default function FilterScreen({ filterConfig, dropdownData, onRenderSearchCallback, onRenderClearCallback }) {
  // INITIAL FILTERS
  const initialFilters = {};

  filterConfig?.forEach((item) => {
    initialFilters[item.key] = [];
  });

  const [selectedFilters, setSelectedFilters] = useState(initialFilters);

  // FINAL FILTERED DATA
  const filteredData = useMemo(() => {
    return dropdownData.filter((row) => {
      return filterConfig?.every(
        ({ key }) => {
          const selected =
            selectedFilters[key];

          if (selected.length === 0) {
            return true;
          }

          return selected.some(
            (item) =>
              (item.actualValue ?? item.value) === row[key]
          );
        }
      );
    });
  }, [selectedFilters, dropdownData]);

  // EXCEL CROSS FILTERING
  const dropdownOptions = useMemo(() => {
    const result = {};

    filterConfig?.forEach((filter) => {
      let tempData = [...dropdownData];

      filterConfig?.forEach((config) => {
        if (config.key !== filter.key) {
          const selected =
            selectedFilters[config.key];

          if (selected.length > 0) {
            tempData = tempData.filter(
              (row) =>
                selected.some(
                  (item) =>
                    (item.actualValue ?? item.value) === row[config.key]
                )
            );
          }
        }
      });

      result[filter.key] =
        getUniqueOptions(
          tempData,
          filter
        );
    });

    return result;
  }, [selectedFilters, dropdownData]);

  // HANDLE CHANGE
  const handleFilterChange = (
    key,
    values
  ) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: values,
    }));
  };

  const onHandleSearch = () => {
    onRenderSearchCallback(selectedFilters);
  }

  const onHandleClear = () => {
    const cleared = {};

    filterConfig?.forEach(
      (item) => {
        cleared[
          item.key
        ] = [];
      }
    );

    setSelectedFilters(
      cleared
    );
    onRenderClearCallback(cleared);
  }


  return (
    <div>
      <Grid
        container
        spacing={2} >
        {filterConfig?.map((filter) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={2.4}
            p={1}
            key={filter.key}
          >
            <FilterMultiSelectExtractSAP
              label={filter.label}
              options={
                dropdownOptions[
                filter.key
                ]
              }
              value={
                selectedFilters[
                filter.key
                ]
              }
              onChange={(values) =>
                handleFilterChange(
                  filter.key,
                  values
                )
              }
            />
          </Grid>
        ))}

      </Grid>
      <div style={{ display: "flex", gap: 12,margin:10,alignItems:'center',justifyContent:'center' }}>
        <ButtonComponent
          type="primary"
          maxWidth="120px"
          label="Clear"
          height="40px"
          onClick={onHandleClear}
        // disabled={!isSearchEnabled || searchTableSelector.loading}
        />
        <ButtonComponent
          type="secondary"
          maxWidth="120px"
          label="Search"
          height="40px"
          onClick={onHandleSearch}
        // disabled={!isSearchEnabled || searchTableSelector.loading}
        />
      </div>
    </div>

  );
}